<!-- <footer class="footer-container">fff
  <div class="footer-content">
    <div class="footer-section about-us">
       <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>
      <p><strong>Hotline:</strong><br>1800-000-0000</p>
      <p>No 5, 12th Main Road, Vijaya Nagar,<br>Velacheri, Chennai - 600 042.</p>
      <p>info@halafresh.com</p>
      <div class="payment-icons">
        <img src="https://i.imgur.com/example-visa.png" alt="Visa">
        <img src="https://i.imgur.com/example-mastercard.png" alt="Mastercard">
        <img src="https://i.imgur.com/example-gpay.png" alt="Google Pay">
        <img src="https://i.imgur.com/example-amex.png" alt="American Express">
      </div>
    </div>

    <div class="footer-section quick-links">
      <h3>QUICK LINKS</h3>
      <ul>
        <li><a href="#">About Us</a></li>
        <li><a href="#">Support</a></li>
        <li><a href="#">Policy</a></li>
        <li><a href="#">Shopping Cart</a></li>
        <li><a href="#">T&C</a></li>
      </ul>
    </div>

    <div class="footer-section download-app">
      <h3>DOWNLOAD APP</h3>
      <a href="#" class="app-store-btn">
        <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store">
      </a>
      <a href="#" class="google-play-btn">
        <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play">
      </a>
    </div>

    <div class="footer-section categories">
      <h3>CATEGORIES</h3>
      <div class="category-tags">
        <a href="#">Fish</a>
        <a href="#">Meat</a>
        <a href="#">Poultry</a>
        <a href="#">Vegetables</a>
        <a href="#" class="active">Mutton</a>
        <a href="#">Ready to Cook</a>
        <a href="#">Steaks</a>
      </div>
    </div>
  </div>

  <div class="copyright-bar">
    <p>Copyright © 2025 Hala Fresh. Designed by TNM Online Solutions</p>
  </div>
</footer> -->


<footer [style.backgroundImage]="'url(' + serverPath1+footerBrandImg + ')'" class="footer-v1" style="max-width: 100%;">
  <div class="theme-container ">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxLayoutAlign="space-around start"
      class="paddingtopbotton">
      <div fxFlex="5"></div>
      <div fxLayout="column" fxLayoutAlign="start start" fxFlex="25" fxLayoutGap="10px">
        <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>
        <div fxLayout="column" fxLayoutAlign="start start">
          <h3><strong style="color: #c7c7c7;">Hotline:</strong><br>{{ data.storePhoneNumber }}</h3>
          <h3 style="color: #c7c7c7;" class="mt-1">
            {{ data.streetAddress | uppercase }}
          </h3>
          <h3> {{ data.smtpUsername }}</h3>
        </div>
        <div class="payment-icons">
          <img src="../../../../assets/icons/Payment.png" alt="Visa">
          <!-- <img src="https://i.imgur.com/example-mastercard.png" alt="Mastercard">
          <img src="https://i.imgur.com/example-gpay.png" alt="Google Pay">
          <img src="https://i.imgur.com/example-amex.png" alt="American Express"> -->
        </div>
      </div>

      <div fxFlex="20" class="footer-section quick-links">
        <h3 class="titlebotton">QUICK LINKS</h3>
        <ul>
          <li><a routerLink="/aboutus">About Us</a></li>
          <li><a routerLink="/contact-us" >Support</a></li>
          <li><a routerLink="/privacy">Policy</a></li>
          <li><a routerLink="/cart">Shopping Cart</a></li>
          <li><a routerLink="/terms&conditions" >T&C</a></li>
          <li><a routerLink="/coupon" >Coupon</a></li>
        </ul>
      </div>

      <div fxFlex="20" fxHide.lt-md class="footer-section download-app">
        <h3 class="titlebotton">DOWNLOAD APP</h3>
        <a href="#" class="app-store-btn">
          <img src="../../../../assets/icons/App Store.png" alt="Download on the App Store">
        </a>
        <a href="#" class="google-play-btn">
          <img src="../../../../assets/icons/Google Play.png" alt="Get it on Google Play">
        </a>
      </div>

      <div fxFlex="20" class="footer-section categories">
        <h3 class="titlebotton">CATEGORIES</h3>
        <div fxLayout="row wrap"  fxLayoutGap="15px">
          <div fxFlex.xs="45" *ngFor="let subcategory of categoryArray" fxFlex>
            <div (click)="goToCategory(subcategory)" class="category-tags">
              <div (click)="goToCategory(subcategory)" style="display: flex;cursor: pointer;">

                <p style="color: #c7c7c7;">
                  {{ subcategory.categoryName }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="category-tags">
          <a href="#">Fish</a>
          <a href="#">Meat</a>
          <a href="#">Poultry</a>
          <a href="#">Vegetables</a>
          <a href="#">Mutton</a>
          <a href="#">Ready to Cook</a>
          <a href="#">Steaks</a>
        </div> -->
      </div>






      <div fxFlex="5"></div>
    </div>

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" class="copyright-bar">
      <!-- <div fxFlex="10"></div>
      <div fxFlex.lt-md="50" fxFlex.gt-md="30">
        <div *ngIf="showFooterIcon==1">
          <span *ngFor="let item of footerIconData; let i = index">

            <button (click)="navigate(item)" mat-icon-button>

              <mat-icon [svgIcon]="item.iconName"> </mat-icon>
            </button>
          </span>

        </div>
      </div>
      <div fxFlex.lt-md="40" fxFlex.gt-md="60">
        <h3 class="mt8">© CALIFORNIA SOFTWARE COMPANY LIMITED. All rights reserved.</h3>
      </div> -->

      <div>
        <p>Copyright © 2025 Hala Fresh. Designed by TNM Online Solutions</p>
      </div>
    </div>
    <!-- <p class="mt-1" style="text-align: center;"><a routerLink="/terms&conditions" >Terms & Conditions</a></p> -->

  </div>

  <!-- <div *ngIf="footerImageEnable==1">
      <div *ngIf="display">
        <div style="margin-top:auto;" fxHide.lt-md>
          <img [src]="serverPath+footerLogoSrc" onerror="this.src='';" style="width: 100%;"/>
        </div>
      </div>
      </div> -->

</footer>